import Api from '@/utils/Api'

/**
 * 报修API
 */
export default class RepairsApi extends Api {

    static getClass () {
        if (!this.instance) {
            this.instance = new RepairsApi();
        }
        return this.instance;
    }


    findPages = (param) => {
        let paramData = {
            userid: param.userid
        }
        return this.$mhttp.httpGet(this.$constant.API_NSC + "order/findAll", paramData, null);
    }

    findOrderById = (id) => {
        return this.$mhttp.httpGet(this.$constant.API_NSC + 'order/findOrderById/' + id, null, null);
    }

    saveOrUpdate = (param) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + 'order/saveOrUpdate', param, "application/json");
    }
     //删除上传文件
     filedel = (fileId) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + 'file/del/' + fileId, null, "application/json");
    }

    // 更新文件状态
    updateFileFlag = (recordId, param) => {
        return this.$mhttp.httpPost(this.$constant.API_NSC + "file/" + recordId + "/updateFlag", param, "application/json");
    }


}